import React from 'react'
import ReactDOM from 'react-dom'
import { Accordion, AccordionDetails, List, ListItem, ListItemText } from '@material-ui/core'
import { ThemeProvider } from '@material-ui/core/styles'
import bookList from '../coregrammar_bookList.json'
import { useStyles, theme } from '../styles/CoreGrammarStyle'

export default function CoreGrammar() {
  const classes = useStyles()

  const ListItemLink = props => (
    <ListItem button component="a" {...props} />
  )

  return (
    <ThemeProvider theme={theme}>
      <div className={classes.root}>
        <Accordion expanded>
          {bookList.CoreGrammar.map((books, index) => (
            <div key={index}>
              {books.map((book, index) => (
                <AccordionDetails className={classes.parentDetails} key={index}>
                  <List component="nav" aria-label="secondary mailbox folders" className={classes.list}>
                    <ListItemLink button href={book.link} target="_blank" referrerPolicy="unsafe-url">
                      <ListItemText primary={book.title} className={classes.listItemText} />
                    </ListItemLink>
                  </List>
                </AccordionDetails>
              ))}
            </div>
          ))}
        </Accordion>
      </div>
    </ThemeProvider>
  )
}

if (document.getElementById('core_grammar')) {
  ReactDOM.render(
    <CoreGrammar />,
    document.getElementById('core_grammar')
  )
}